import { formatDateToStringIgnoreUTC } from '~/helpers'
import i18n from '~/i18n'

const EMPTY_VALUE = '—'

const channelLabelKeys = {
  dv360: 'rm:campaign.offsite.channel.dv360',
  meta: 'rm:campaign.offsite.channel.meta'
} as const satisfies Record<OffsiteChannel, string>

/**
 * Mapeia a fila para exibição. O recorte é do servidor, que filtra antes de
 * paginar e contar: refiltrar aqui descolaria as linhas do envelope.
 */
export const formatOffsiteAdvertiserReviewList = (
  data: OffsiteAdvertiserReviewQueueItem[]
) => {
  if (!data) return []

  return data.map(campaign => {
    const channel = campaign.settings?.channel
    const channelLabelKey =
      typeof channel === 'string' && Object.hasOwn(channelLabelKeys, channel)
        ? channelLabelKeys[channel]
        : null

    return {
      _raw: {
        originPath:
          'src/modules/retailMedia/components/_tables/OffsiteAdvertiserReviewTable/DTO.ts'
      },
      raw: campaign,
      id: campaign.id,
      title: campaign.name,
      status: campaign.status,
      channel: channelLabelKey ? i18n.t(channelLabelKey) : EMPTY_VALUE,
      destinationRetailer: campaign.destination_retailer?.name || EMPTY_VALUE,
      createdAt: campaign.created_at,
      // Datas de veiculação vêm em UTC representando o dia local da campanha
      startDate: formatDateToStringIgnoreUTC(campaign.start_at, 'DD/MM/YY'),
      endDate: campaign.end_at
        ? formatDateToStringIgnoreUTC(campaign.end_at, 'DD/MM/YY')
        : i18n.t('rm:indefinite')
    }
  }) as FormatOffsiteAdvertiserReviewList[]
}
